{
  "name": "odss-mobile",
  "private": true,
  "version": "6.3.8",
  "author": "Masahiko Sakakibara",
  "engines": {
    "node": "^20.0.0"
  },
  "scripts": {
    "fmt": "npm run fmt:app && npm run fmt:hono",
    "fmt:app": "prettier --parser typescript --write \"app/projects/**/*.ts\" && prettier --parser angular --write \"./app/projects/**/*.html\"",
    "lint": "cd hono && npm run lint && cd ../app && npm run lint",
    "lint:fix": "cd hono && npm run lint:fix && cd ../app && npm run lint -- --fix",
    "release": "np --no-publish --yolo",
    "prepare": "husky",
    "fmt:hono": "prettier --parser typescript --write \"./hono/src/**/*.ts\" \"./hono/testing/**/*.ts\"",
    "fmt:check:app": "prettier --parser typescript --check \"app/projects/**/*.ts\" && prettier --parser angular --check \"./app/projects/**/*.html\"",
    "fmt:check:hono": "prettier --parser typescript --check \"./hono/src/**/*.ts\" \"./hono/testing/**/*.ts\"",
    "fmt:check": "npm run fmt:check:app && npm run fmt:check:hono",
    "docs:generate": "npm --prefix hono run docs:generate",
    "docs:check": "npm --prefix hono run docs:check"
  },
  "repository": {
    "type": "git",
    "url": "git@github.com:odss-team/odss-mobile.git"
  },
  "bugs": {
    "url": "git@github.com:odss-team/odss-mobile.git/issues"
  },
  "devDependencies": {
    "husky": "^9.1.7",
    "lint-staged": "^15.5.2",
    "np": "^10.3.0",
    "pre-commit": "^1.2.2",
    "prettier": "^3.9.1"
  },
  "lint-staged": {
    "*.ts": [
      "prettier --parser typescript --write"
    ],
    "*.html": [
      "prettier --parser angular --write"
    ]
  }
}
